// /api/v1/me — caller's own profile + SSH keys.

import useSWR from 'swr';

export interface SSHKey {
  id: string;
  name: string;
  fingerprint: string;
  public_key?: string;
  created_at: string;
  last_used_at?: string;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useSSHKeys() {
  return useSWR<SSHKey[]>('/api/v1/me/ssh-keys', fetcher);
}

export async function addSSHKey(input: { name: string; public_key: string }): Promise<SSHKey> {
  const res = await fetch('/api/v1/me/ssh-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteSSHKey(id: string): Promise<void> {
  const res = await fetch(`/api/v1/me/ssh-keys/${id}`, {
    method: 'DELETE', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw new Error(`delete failed: ${res.status}`);
}
